import React, { useState } from "react";
import { useTheme } from "../../theme";

const ThemeSwitcher = ({ variant = "button" }) => {
    const { themePreference, setThemePreference, effectiveTheme } = useTheme();
    const [showThemeMenu, setShowThemeMenu] = useState(false);

    const themeOptions = [
        { value: "system", label: "System", icon: "fa-display" },
        { value: "light", label: "Light", icon: "fa-sun" },
        { value: "dark", label: "Dark", icon: "fa-moon" },
    ];

    const isFloating = variant === "floating";

    return (
        <div className={isFloating ? "fixed right-4 top-4 z-[999999]" : "relative"}>
            <button
                type="button"
                className={`${isFloating ? "bg-white/90 dark:bg-slate-900/90 shadow-1 border border-slate-100 dark:border-slate-700" : ""} relative flex items-center justify-center w-10 h-10 rounded-full hover:bg-slate-100 dark:hover:bg-slate-800 text-[#5a6a85] dark:text-slate-300 hover:text-blue-600 dark:hover:text-sky-400 transition-colors`}
                title="Theme"
                onClick={() => setShowThemeMenu(prev => !prev)}
            >
                <i className={`fa-solid ${effectiveTheme === "dark" ? "fa-moon" : "fa-sun"} text-lg`}></i>
            </button>

            {showThemeMenu && (
                <>
                    <button
                        type="button"
                        className="fixed inset-0 z-[999998] cursor-default"
                        aria-label="Close theme menu"
                        onClick={() => setShowThemeMenu(false)}
                    />
                    <div className="absolute right-0 top-[calc(100%+0.6rem)] z-[999999] w-44 overflow-hidden rounded-xl border border-slate-100 bg-white shadow-3 dark:border-slate-700 dark:bg-slate-900">
                        {themeOptions.map(option => (
                            <button
                                key={option.value}
                                type="button"
                                className={`flex w-full items-center gap-3 px-4 py-3 text-left text-sm font-semibold transition-colors ${
                                    themePreference === option.value
                                        ? "bg-blue-50 text-blue-600 dark:bg-sky-500/15 dark:text-sky-300"
                                        : "text-slate-600 hover:bg-slate-50 dark:text-slate-300 dark:hover:bg-slate-800"
                                }`}
                                onClick={() => {
                                    setThemePreference(option.value);
                                    setShowThemeMenu(false);
                                }}
                            >
                                <i className={`fa-solid ${option.icon} w-4 text-center`}></i>
                                <span>{option.label}</span>
                                {themePreference === option.value && (
                                    <i className="fa-solid fa-check ml-auto text-xs"></i>
                                )}
                            </button>
                        ))}
                    </div>
                </>
            )}
        </div>
    );
};

export default ThemeSwitcher;
